import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "tw-text-22 tw-hidden sm:tw-block"
};
var _hoisted_2 = {
  class: "tw-flex tw-flex-col tw-items-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_base_alert = _resolveComponent("base-alert");
  var _component_BaseBtModal = _resolveComponent("BaseBtModal");
  return _openBlock(), _createBlock(_component_BaseBtModal, {
    id: "generic-success-modal",
    "show-modal": _ctx.show,
    "custom-modal-dialog-classes": "modal-lg",
    "custom-modal-header-classes": "modal-header tw-py-10px sm:tw-pt-25px sm:tw-pb-0 tw-px-5px sm:tw-px-25px tw-flex tw-justify-between",
    "custom-modal-body-classes": "modal-body tw-pt-0 tw-mb-30px sm:tw-mb-0",
    "auto-close": _ctx.autoClose,
    onOpened: _ctx.onOpened,
    onClosed: _ctx.onClosed
  }, {
    header: _withCtx(() => [_ctx.labels.actual_title ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(_ctx.labels.actual_title), 1 /* TEXT */)) : _createCommentVNode("v-if", true)]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_base_alert, {
      "alrt-class": "tw-alert-w-primary tw-m-0 tw-w-full tw-text-16 tw-mt-30px sm:tw-mt-10px",
      text: _ctx.labels.actual_label
    }, null, 8 /* PROPS */, ["text"])])]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show-modal", "auto-close", "onOpened", "onClosed"]);
}